import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { SearchIcon } from 'tdesign-icons-react';
import { Collapse, Input } from 'tdesign-react';
import Highlighter from 'react-highlight-words';
import { fetchHostsUnderCluster } from '@/slices/resourceSlice';
import ConnectModal from './ConnectModal';

const { Panel } = Collapse;

function Left({ clusters, fetchHostsUnderCluster, loading }) {
  const [filter, setFilter] = useState('');
  const [collapseValue, setCollapseValue] = useState([]);
  const [host, setHost] = useState({});
  const [visible, setVisible] = useState(false);

  const searchWords = filter.split(/\s/).filter((word) => word);

  useEffect(() => {
    // 简单重置，暂不交互
    setHost({});
  }, [loading]);

  const onChange = (value) => {
    const clusterId = value[0];
    setCollapseValue(value);
    if (clusterId) {
      fetchHostsUnderCluster({
        opsClusterId: clusterId,
        pageSize: 99999,
        startIndex: 1,
        all: 1,
      });
    }
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Root>
      <Title>集群列表</Title>
      <Input
        style={{ margin: '0 20px 12px', width: 'auto' }}
        onChange={setFilter}
        placeholder='请输入集群'
        clearable
        suffixIcon={<SearchIcon />}
      />
      <Content className='narrow-scrollbar'>
        <Collapse
          expandMutex
          borderless
          expandIconPlacement='right'
          value={collapseValue}
          onChange={onChange}
        >
          {clusters
            .filter((item) => item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1)
            .map((item) => (
              <Panel
                key={item.id}
                value={item.id}
                header={
                  <Highlighter
                    activeIndex={-1}
                    highlightStyle={{
                      color: 'var(--td-brand-color-7)',
                      fontWeight: 'bold',
                      background: 'transparent',
                    }}
                    searchWords={searchWords}
                    textToHighlight={item.name}
                  />
                }
              >
                {item.hosts?.map((_host) => (
                  <Item
                    onClick={() => {
                      setHost({ ..._host, clusterId: item.id });
                      setVisible(true);
                    }}
                    active={host.id === _host.id}
                    key={`${item.id}/${_host.id}`}
                  >
                    {_host.serviceIp || _host.hostIp}
                  </Item>
                ))}
              </Panel>
            ))}
        </Collapse>
      </Content>
      <ConnectModal detail={host} visible={visible} handleClose={handleClose} />
    </Root>
  );
}

export default connect(
  (state) => ({
    clusters: state.resource.clusters.filter((item) => item.type === 0), // 仅主机类型,
    loading: state.resource.clusterHostsFetching,
  }),
  {
    fetchHostsUnderCluster,
  },
)(Left);

const Root = styled.div`
  width: 240px;
  padding: 24px 0 0 1px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  color: var(--td-font-gray-1);
  font-size: 14px;
  padding: 0 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const Content = styled.div`
  padding-left: 12px;
  overflow-y: auto;
  height: calc(100vh - 235px);
  .t-collapse-panel__content {
    padding: 0;
    color: var(--td-text-color-primary);
  }
`;

const Item = styled.div`
  height: 33px;
  line-height: 33px;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 24px;
  cursor: pointer;
  position: relative;
  ${(props) =>
    props.active &&
    ` 
      background: #F7F8FA;
      color: var(--td-brand-color-7);
      font-weight: bold;
      border-right: 2px solid var(--td-brand-color-7);
    `}
`;
